import React, { createContext, useContext } from "react";
import useReducedMotion from "../../hooks/useReducedMotion";

const ReducedMotionContext = createContext(false);

/**
 * ReducedMotionController — provides prefers-reduced-motion state to the
 * whole tree via context, so deeply nested components (GSAP effects,
 * parallax) can check it without re-subscribing to the media query.
 */
export function ReducedMotionProvider({ children }) {
  const reduced = useReducedMotion();
  return <ReducedMotionContext.Provider value={reduced}>{children}</ReducedMotionContext.Provider>;
}

export function useReducedMotionContext() {
  return useContext(ReducedMotionContext);
}
